<template>
  <div class="device-category">
    <CurrentCategory
      :title="categories.head.title"
      :icon-name="categories.head.icon"
      :select-categories="selectedItems"
    />

    <div v-if="categories.items" class="device-category__items">
      <CategoryDropdown
        v-for="item in categories.items"
        :key="item.index"
        :category="categories.head.categoryName"
        :data-item="item"
      />
    </div>
  </div>
</template>

<script setup>
import CurrentCategory from "~~/modules/calculators/powerCalculator/components/UI/CurrentCategory.vue";
import CategoryDropdown from "~~/modules/calculators/powerCalculator/components/UI/CategoryDropdown.vue";
import { usePowerCalcStore } from "~/store/powerCalcStore";

const powerCalculatorStore = usePowerCalcStore();

const props = defineProps({
  categories: { type: Object, required: true },
});

const selectedItems = computed(() => {
  const currenCategory = props.categories.head.categoryName;

  return powerCalculatorStore.getSelectedItemsByCategory(currenCategory);
});
</script>

<style lang="scss" scoped>
.device-category {
  @include flex-container(column);

  gap: 32px;

  @include bigMobile() {
    gap: 16px;
  }

  &__items {
    @include flex-container(row, flex-start);
    flex-wrap: wrap;

    gap: 16px;

    @include bigMobile() {
      gap: 8px;
    }
  }
}
</style>
